import React, { useState, useEffect } from "react";
import { withRouter } from "react-router";
import { useSnackbar } from 'notistack';
import { SortableContainer, SortableElement, } from "react-sortable-hoc";
import moment from "moment";
import { Table, TableBody, TableCell, TableHead, TableRow, Paper, Grid, Button, TextField, Dialog, DialogContent, DialogTitle, DialogActions, Tooltip, CircularProgress, FormControl, FormLabel, RadioGroup, FormControlLabel, Radio } from '@material-ui/core';
import { Edit as EditIcon, DeleteOutline as DeleteOutlineIcon, } from '@material-ui/icons';
import AddInteriorItem from './AddInteriorItem'
import { Pagination, STableLoader, PageLoader, EmptyCollection, DeletePopUp } from '../../shared_elements';
import { checkApiStatus, checkPermission, } from '../../utils_v2';
import { globalGetService, globalPutService, globalPostService, globalDeleteService, globalExportService } from '../../../globalServices';
import { downloadFileType } from "../../../utils";
import { assetTypeValues, backendDateFormat } from "../../../constants";
import { trackActivity } from "../../../utils/mixpanel";
import { titanAviInstance } from "../../../shared/components";
import { getPermissionKey } from "..";

const avionicsCommObj = {
    item: "",
    description: "",
    remarks: "",
}
const AvionicsCommHd = () => {
    return (
        <TableHead>
            <TableRow>
                <TableCell>Action(s)</TableCell>
                <TableCell>Item</TableCell>
                <TableCell>Description</TableCell>
                <TableCell>Remarks</TableCell>
            </TableRow>
        </TableHead>
    )
}
const SortableBodyContainer = SortableContainer(({ avionicsCommInfo, setAddEditAvionicsComm, setDeleteAvionicsComm, params }) => {
    return (
        <TableBody>
            {avionicsCommInfo?.list?.map((item, index) =>
                <AvionicsCommunicationList
                    key={`item-${index}`}
                    index={index}
                    sortIndex={index}
                    item={item}
                    onEdit={() => setAddEditAvionicsComm({ modal: true, data: item })}
                    onDelete={() => setDeleteAvionicsComm({ modal: true, data: item })}
                    params = {params}
                />
            )}
        </TableBody>
    );
});

const AvionicsCommunicationList = SortableElement(({ item, onEdit, onDelete, params }) => {
    const [showMore, setShowMore] = useState({});
    const toggleDescription = (field) => {
        setShowMore({
            ...showMore,
            [field]: !showMore[field],
        });
    };
    return (
        <TableRow>
            <TableCell align="left">
                <ul className="list-inline">
                    {checkPermission('technical_specs', getPermissionKey(params.type), 'U') ?
                    <li className="list-inline-item hover-inline" onClick={onEdit}>
                        <Tooltip title='Edit' arrow><EditIcon color="primary" fontSize="small" /></Tooltip>
                    </li>:null}
                    {checkPermission('technical_specs', getPermissionKey(params.type), 'U') ?
                    <li className="list-inline-item hover-inline" onClick={onDelete}>
                        <Tooltip title='Delete' arrow><DeleteOutlineIcon color="secondary" fontSize="small" /></Tooltip>
                    </li> :null}
                </ul>
            </TableCell>
            <TableCell>
                <div style={{ width: '300px' }} >{item?.item || '--'}</div>
            </TableCell>
            <TableCell>
                <div style={{ width: '300px' }} >{item?.description || '--'}</div>
            </TableCell>
            <TableCell>
                {item?.remarks && item?.remarks?.length > 30 ? (
                    <div style={{ width: '400px' }}>
                        {showMore[item?.field] ? (
                            <span>
                                <span dangerouslySetInnerHTML={{ __html: item?.remarks && item?.remarks.replace(/\n/g, '<br />') }} />
                                <a href="#" style={{ color: '#0E7FE1', fontSize: '12px' }} onClick={(e) => { e.preventDefault(); toggleDescription(item.field); }} > {" "}less </a>
                            </span>
                        ) : (
                            <span>
                                <span dangerouslySetInnerHTML={{ __html: item?.remarks && item?.remarks.substring(0, 25).replace(/\n/g, '<br />'), }} />
                                <a href="#" style={{ color: '#0E7FE1', fontSize: '12px' }} onClick={(e) => { e.preventDefault(); toggleDescription(item.field); }} > {" "}..more </a>
                            </span>
                        )}
                    </div>
                ) : (
                    <div dangerouslySetInnerHTML={{ __html: item?.remarks || '--', }} />
                )}
            </TableCell>
        </TableRow>
    )
})
const AddEditAvionicsCommunication = ({ params, addEditAvionicsComm, toggleModalFn, getResponseBack, assetInfoData }) => {
    const { enqueueSnackbar, } = useSnackbar();
    const [isLoading, setLoading] = useState(false);
    const [avionicsComm, setAvionicsComm] = useState(addEditAvionicsComm?.data);
    const [error, setError] = useState({});
    const onFieldChange = (key, value) => { setAvionicsComm({ ...avionicsComm, [key]: value }) }
    const onAddEditAvionicsComm = () => {
            let validationInputs={
            item:avionicsComm?.item.trim()? '':'Please enter Item'
        }
        if(Object.keys(validationInputs).every(k=>validationInputs[k]==='')){
        setLoading(true)
        if (avionicsComm.id) {
            globalPutService(`console/v2/asset/${params.type}/${params.aircraft_slug}/avionics_config_details/${avionicsComm.id}/`, avionicsComm)
                .then(response => {
                    if (checkApiStatus(response)) {
                        enqueueSnackbar(response.data.message, { variant: 'success', anchorOrigin: { horizontal: 'right', vertical: 'top' } });
                        toggleModalFn(); getResponseBack();
                        trackActivity('Console Management', { data:JSON.stringify(avionicsComm), page_title: titanAviInstance ? 'Navigation/Communication' : 'Avionics Communication', asset_type: 'MSN', asset_name: assetInfoData?.serial_number, event_type: 'Item Edited', event_desc: titanAviInstance ? 'Added Navigation/Communication data from Add Navigation/Communication form' : 'Edited Avionics & Communication data from Edit Avionics & Communication form' })
                    }
                    setLoading(false)
                })
        } else {
            globalPostService(`console/v2/asset/${params.type}/${params.aircraft_slug}/avionics_config_details/`, avionicsComm)
                .then(response => {
                    if (checkApiStatus(response)) {
                        enqueueSnackbar(response.data.message, { variant: 'success', anchorOrigin: { horizontal: 'right', vertical: 'top' } });
                        trackActivity('Console Management', { data:JSON.stringify(avionicsComm), page_title: titanAviInstance ? 'Navigation/Communication':'Avionics Communication', asset_type: 'MSN', asset_name: assetInfoData?.serial_number, event_type: 'Item Added', event_desc: titanAviInstance ? 'Added Navigation/Communication data from Add Navigation/Communication form' : 'Added Avionics & Communication data from Add Avionics & Communication form' })
                        toggleModalFn(); getResponseBack();
                    }
                    setLoading(false)
                })
        } }else{
            setError(validationInputs)
        }
    }
    return (
        <Dialog
            open={addEditAvionicsComm.modal}
            onClose={toggleModalFn}
            className='console-management-modal'
            maxWidth="md"
        >
            <DialogTitle id="scroll-dialog-title">
                {avionicsComm?.id ? 'Edit ' : 'Add '} {titanAviInstance ? 'Navigation/Communication' : 'Avionics & Communication'}
            </DialogTitle>
            <DialogContent dividers={true}>
                <Grid container spacing={1}>
                    <Grid item md={6}>
                        <TextField
                            required
                            name='item'
                            label='Item'
                            value={avionicsComm?.item || ''}
                            fullWidth
                            margin="normal"
                            onChange={(e) => onFieldChange('item', e.target.value.trimStart())}
                            error={error?.item || false}
                            helperText={error?.item ? error?.item :''}
                            onFocus={()=>{setError({...error, item:''})}}
                            InputLabelProps={{ shrink: true }}
                            variant='outlined'
                            inputProps={{ maxLength: 50 }}
                        />
                    </Grid>
                    <Grid item md={6}>
                        <TextField
                            name='description'
                            label='Description'
                            value={avionicsComm?.description || ''}
                            fullWidth
                            margin="normal"
                            onChange={(e) => onFieldChange('description', e.target.value.trimStart())}
                            InputLabelProps={{ shrink: true }}
                            variant='outlined'
                            inputProps={{ maxLength: 100 }}
                        />
                    </Grid>
                    <Grid item md={12}>
                        <TextField
                            name='remarks'
                            label='Remarks'
                            value={avionicsComm?.remarks || ''}
                            fullWidth
                            multiline
                            rows={3}
                            margin="normal"
                            onChange={(e) => onFieldChange('remarks', e.target.value.trimStart())}
                            InputLabelProps={{ shrink: true }}
                            variant='outlined'
                            inputProps={{ maxLength: 255 }}
                        />
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button disabled={isLoading} onClick={toggleModalFn} color='primary' size='small' variant='outlined'>Cancel</Button>
                <Button disabled={isLoading} onClick={onAddEditAvionicsComm} color='primary' size='small' variant='contained'>
                    {isLoading ? <CircularProgress size={24} /> : 'Save'}
                </Button>
            </DialogActions>
        </Dialog>
    )
}
const AvionicsCommunication = ({ params, assetInfoData }) => {
    const { enqueueSnackbar } = useSnackbar();
    const [isLoading, setLoading] = useState(false);
    const [skeletonLoader, setSkeletonLoader] = useState(false);
    const [filter, setFilter] = useState({});
    const [avionicsCommInfo, setAvionicsCommInfo] = useState({ list: [], pagination: null });
    const [addEditAvionicsComm, setAddEditAvionicsComm] = useState({ modal: false, data: null });
    const [deleteAvionicsComm, setDeleteAvionicsComm] = useState({ modal: false, data: null });
    useEffect(() => { getAvionicsComm({per_page:50}, 'skeletonLoader'); }, []);
    const getAvionicsComm = (query = {}, loaderType) => {
        loaderType === 'skeletonLoader' ? setSkeletonLoader(true) : setLoading(true)
        globalGetService(`console/v2/asset/${params.type}/${params.aircraft_slug}/avionics_config_details/`, query)
            .then(response => {
                if (checkApiStatus(response)) {
                    setAvionicsCommInfo(response.data.data)
                }
                loaderType === 'skeletonLoader' ? setSkeletonLoader(false) : setLoading(false)
            })
    }
    const onDeleteAvionicsComm = () => {
        setLoading(true);
        globalDeleteService(`console/v2/asset/${params.type}/${params.aircraft_slug}/avionics_config_details/${deleteAvionicsComm.data.id}/`)
            .then(response => {
                if (checkApiStatus(response)) {
                    setDeleteAvionicsComm({ modal: false, data: null });
                    enqueueSnackbar(response.data.message, { variant: 'success', anchorOrigin: { horizontal: 'right', vertical: 'top' } });
                    getAvionicsComm({per_page:avionicsCommInfo?.pagination?.per_page}, 'pageLoader');
                }
                setLoading(false);
            })
    }
    const onExportAvionicsComm = (type) => {
        setLoading(true);
        let updatedApiUrl;
        let exportName;
        if (type === "sample") {
            const basePath = `console/v2/asset/aircraft/${params.aircraft_slug}/avionics_config_details/`;
            updatedApiUrl = `${basePath}?download=xlsx`;
            exportName = `${assetTypeValues[assetInfoData?.asset_type.type].label}-${assetInfoData?.serial_number}_Avionics_Communication ${moment().format(backendDateFormat)}_sample`
        } else {
            updatedApiUrl = `console/v2/asset/aircraft/${params.aircraft_slug}/avionics_config_details/export/`;
            exportName = `${assetTypeValues[assetInfoData?.asset_type.type].label}-${assetInfoData?.serial_number}_Avionics_Communication ${moment().format(backendDateFormat)}`
        }
        globalExportService(updatedApiUrl)
            .then(response => {
                downloadFileType(response,exportName , 'xlsx')
                trackActivity('Console Management', { page_title: 'Avionics & Communication', asset_type: 'MSN', asset_name: `${assetInfoData?.serial_number}`, event_type: 'Item Exported', event_desc: `Avionics & Communication Exported Successfully`, file_extension: 'xlsx' })
                setLoading(false)
            });
    }

    return (
        <div style={{ padding: '10px' }}>
            {skeletonLoader ? <STableLoader count={7}  size={7}/> :
                <>
                    <AddInteriorItem
                        addPermission={checkPermission('technical_specs', getPermissionKey(params.type), 'C') || false}
                        exportPermission={true}
                        onAddItem={() => setAddEditAvionicsComm({ modal: true, data: avionicsCommObj })}
                        isExport
                        isImport
                        isSampleExport={true}
                        item={avionicsCommInfo}
                        onExport={onExportAvionicsComm}
                        getResponseBack={() => getAvionicsComm({}, 'skeletonLoader')}
                        trackActivity={trackActivity('Console Management', { page_title: titanAviInstance ? 'Navigation/Communication' : 'Avionics & Communication', asset_type: 'MSN', asset_name: `${assetInfoData?.serial_number}`, event_type: 'Item Imported', event_desc: titanAviInstance ? 'Navigation/Communication Imported Successfully' : 'Avionics & Communication Imported Successfully', file_extension: 'xlsx' })}
                        url={`/console/v2/asset/aircraft/${params.aircraft_slug}/avionics_config_details/import/`}
                    />
                    <Paper square>
                        <div style={{height:`${window.innerHeight -  (avionicsCommInfo?.list?.length ? 330 : 280)}px`,overflow:'auto'}}>
                        <Table className='mui-table-format' stickyHeader>
                            <AvionicsCommHd />
                            <SortableBodyContainer
                                useDragHandle
                                avionicsCommInfo={avionicsCommInfo}
                                setAddEditAvionicsComm={setAddEditAvionicsComm}
                                setDeleteAvionicsComm={setDeleteAvionicsComm}
                                params={params}
                            />
                        </Table>
                        {!avionicsCommInfo?.list?.length ? <div style={{ textAlign: 'center' }}><EmptyCollection title='No records found' /></div> : null}
                        </div>
                    </Paper>
                    {avionicsCommInfo?.pagination ?
                        <Paper square>
                            <Pagination
                                pagination={avionicsCommInfo.pagination}
                                onChangePage={(event, newPage) => getAvionicsComm({ ...filter, page: newPage + 1, per_page: avionicsCommInfo.pagination.per_page }, 'pageLoader')}
                                onChangeRowsPerPage={(event) => getAvionicsComm({ ...filter, page: 1, per_page: event.target.value }, 'pageLoader')}
                            />
                        </Paper>
                        : null
                    }
                </>
            }
            {addEditAvionicsComm.modal ?
                <AddEditAvionicsCommunication
                    params={params}
                    assetInfoData={assetInfoData}
                    addEditAvionicsComm={addEditAvionicsComm}
                    toggleModalFn={() => setAddEditAvionicsComm({ modal: false, data: null })}
                    getResponseBack={() => getAvionicsComm({per_page:avionicsCommInfo?.pagination?.per_page }, 'pageLoader')}
                /> : null
            }
            {deleteAvionicsComm.modal ?
                <DeletePopUp
                    modal={deleteAvionicsComm.modal}
                    title={titanAviInstance ? 'Delete Navigation/Communication' : 'Delete Avionics & Communication'}
                    content={`Are you sure, you want to Delete?`}
                    toggleModalFn={() => setDeleteAvionicsComm({ modal: false, data: null })}
                    deleteRecordFn={onDeleteAvionicsComm}
                /> : null
            }
            {isLoading ? <PageLoader /> : null}
        </div>
    )
}
export default withRouter(AvionicsCommunication);
